import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import id from "./locales/id.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import zh from "./locales/zh.json";
import ko from "./locales/ko.json";
import ja from "./locales/ja.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { id: { translation: id }, en: { translation: en }, ar: { translation: ar }, fr: { translation: fr }, es: { translation: es }, zh: { translation: zh }, ko: { translation: ko }, ja: { translation: ja } },
    fallbackLng: "id",
    supportedLngs: ["id", "en", "ar", "fr", "es", "zh", "ko", "ja"],
    detection: { order: ["querystring", "localStorage", "navigator"], lookupQuerystring: "lng", caches: ["localStorage"] },
    interpolation: { escapeValue: false },
  });

const META = {
  id: { title: "Agrodyke — Pupuk Organik Bubuk untuk Panen Melimpah | PT. Dahliah Duta Utama", desc: "Pupuk organik bubuk multiguna Agrodyke. Tingkatkan hasil panen hingga 40% secara alami. Tersedia 1 kg, 2 kg, dan 5 kg." },
  en: { title: "Agrodyke — Organic Powder Fertilizer for Abundant Harvests", desc: "Multipurpose organic powder fertilizer. Naturally increase yields by up to 40%. Available in 1 kg, 2 kg, and 5 kg." },
  ar: { title: "أجرودايك — سماد عضوي لمحصول وفير", desc: "سماد عضوي متعدد الاستخدامات. زد محصولك بنسبة تصل إلى 40% طبيعياً. متوفر بعبوات 1 و2 و5 كغ." },
  fr: { title: "Agrodyke — Engrais Organique en Poudre pour Récoltes Abondantes", desc: "Engrais organique polyvalent. Augmentez vos rendements jusqu'à 40% naturellement. Disponible en 1, 2 et 5 kg." },
  es: { title: "Agrodyke — Fertilizante Orgánico en Polvo para Cosechas Abundantes", desc: "Fertilizante orgánico multiusos. Aumenta tu rendimiento hasta un 40% de forma natural. Disponible en 1, 2 y 5 kg." },
  zh: { title: "Agrodyke — 助力丰收的有机粉末肥料", desc: "多用途有机肥料。天然提升产量高达40%。" },
  ko: { title: "Agrodyke — 풍성한 수확을 위한 유기질 분말 비료", desc: "다목적 유기질 비료. 수확량을 자연적으로 최대 40% 향상." },
  ja: { title: "Agrodyke — 豊かな収穫のための有機粉末肥料", desc: "多目的有機肥料。収穫量を自然に最大40%向上。" },
};

const applyDir = (lng) => {
  const lang = lng?.split("-")[0] || "id";
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lang;
  const meta = META[lang] || META.id;
  document.title = meta.title;
  const d = document.querySelector('meta[name="description"]');
  if (d) d.setAttribute("content", meta.desc);
};
applyDir(i18n.language?.split("-")[0] || "id");
i18n.on("languageChanged", applyDir);

export default i18n;
